import type { ComponentProps } from "react";
import { Switch as SwitchPrimitive } from "radix-ui";

import { cn } from "@jbnl/shared-ui";

/**
 * A toggle where the control *is* the setting, rather than one of a ticked set. On is Ocean Blue,
 * since ADR-0025 keeps red for primary actions.
 */
function Switch({
  className,
  ...props
}: ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer inline-flex h-5 w-9 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none",
        "focus-visible:ring-[3px] focus-visible:ring-ring/45",
        "disabled:cursor-not-allowed disabled:opacity-45",
        "data-[state=unchecked]:bg-input data-[state=checked]:bg-secondary",
        className,
      )}
      {...props}
    >
      {/* Slides rather than appears: the thumb's position is the state for a reader who cannot
          use the colour, the same way the checkbox's tick is. */}
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "pointer-events-none block size-4 rounded-full bg-background ring-0 transition-transform",
          "data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-[18px]",
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
